var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressIndicator66(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C13.7554 2 15.4798 2.46206 17 3.33975C18.5202 4.21743 19.7826 5.47981 20.6603 7C21.5379 8.52019 22 10.2446 22 12C22 13.7554 21.5379 15.4798 20.6603 17C19.7826 18.5202 18.5202 19.7826 17 20.6603C15.4798 21.5379 13.7554 22 12 22C10.2446 22 8.52019 21.5379 7 20.6603C5.47981 19.7826 4.21743 18.5202 3.33975 17L7.66987 14.5C8.10871 15.2601 8.7399 15.8913 9.5 16.3301C10.2601 16.769 11.1223 17 12 17C12.8777 17 13.7399 16.769 14.5 16.3301C15.2601 15.8913 15.8913 15.2601 16.3301 14.5C16.769 13.7399 17 12.8777 17 12C17 11.1223 16.769 10.2601 16.3301 9.5C15.8913 8.7399 15.2601 8.10871 14.5 7.66987C13.7399 7.23103 12.8777 7 12 7V2Z",
    fill: "#CF2F92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIndicator66);
export default __webpack_public_path__ + "static/media/ProgressIndicator66.c725b42f00624319f20f938366a5c77b.svg";
export { ForwardRef as ReactComponent };